import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeneralSearch } from '../api/general-search';
import { SearchItem } from '../api/search-item';

@Injectable()
export class ApplicantService {

  constructor(private httpClient: HttpClient) {
  }

  public getApplicants(searchRequirements: GeneralSearch): Observable<SearchItem[]> {
    const url = '/patent/open/report/search/applicant';

    return this.httpClient.post<SearchItem[]>(url, searchRequirements);
  }
}
